import { Injectable } from '@angular/core';
import {Http, Response} from '@angular/http';
import {Router} from '@angular/router';
import {ParentService} from '../ParentClass/ParentService';
import {constant} from '../../../app.constants';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class FacilitiesPayorService extends  ParentService {

  constructor( private http: Http, private route: Router) {
    super();
    // this.verifyToken(this.http, route);
  }

  getFacilitysParyor(id) {
    return this.http.get(constant.URL_PAYOR_FACILITY_2 + id, this.getHeader())
      .map(resp => resp.json());
  }

  postFacilitysParyor(body) {

    const bodyString = JSON.stringify(body);
    return this.http.post(constant.URL_PAYOR_FACILITIES, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  deleteFacilitysParyor(id) {

    return this.http.delete(constant.URL_PAYOR_FACILITIES + '/' + id, this.headerPost())
      .map((res: Response) => res.json() )
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getListAllByPayorFacility(data) {
    return this.http.post(constant.URL_PAYOR_FACILITIES + `/ListAllByPayor`, data, this.headerPost())
      .map(resp => resp.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/facilities-payor/facilities-payor.service.ts